import { RemoteHandleStudentsWithoutRegisteringApp } from 'data/usecases';
import { HandleStudentsWithoutRegisteringApp } from 'domain/usecases';
import { makeApiUrlStudentsWithoutRegisteringApp } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeHandleStudentsWithoutRegisteringApp =
  (): HandleStudentsWithoutRegisteringApp =>
    new RemoteHandleStudentsWithoutRegisteringApp(
      makeApiUrlStudentsWithoutRegisteringApp(),
      makeAxiosHttpClient(),
    );
